<template>
  <div class="book-layout">
    <div v-if="customerBooked" class="text-center">
      <feather-icon
        icon="CheckCircleIcon"
        size="64"
        class="mb-2 mt-5 text-success"
      />
      <h2>
        Thanks for booking! Please check your email for confirmation and further
        details. We look forward to your package!
      </h2>
    </div>
    <template v-else>
      <b-row class="mb-2">
        <b-col>
          <h1>Book Your Package</h1>
        </b-col>
      </b-row>
      <div v-if="isLoading" class="text-center pt-3">
        <b-spinner label="Loading..." />
      </div>
      <template v-else>
<!--        <validation-observer ref="bookPackageValidation">-->
          <b-row class="mb-3">
            <b-col cols="12" class="mb-2">
              <h3>Select A Unit To Book</h3>
            </b-col>
            <b-col cols="12">
              <b-card-group deck class="justify-content-left">
                <b-card
                  v-for="unit in unitNamesPackagesPictures"
                  :key="unit.id"
                  no-body
                  :img-src="'//' + unit.picture"
                  :img-alt="unit.name"
                  img-top
                  :class="'unit-block mb-2'"
                >
                  <b-card-body>
                    <b-form-radio
                      v-model="chosenUnit"
                      name="checkbox-unit"
                      :value="unit.id"
                    >
                      <h4 class="unit-name">
                        {{ unit.name }}
                      </h4>
                    </b-form-radio>
                  </b-card-body>
                </b-card>


              </b-card-group>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="4">

              <template v-if="chosenUnit > 0">
                <h5>Select the package:</h5>
<!--                <validation-provider #default="{ errors }" name="package" rules="required">-->
                  <v-select
                    id="select-package-name"
                    v-model="chosenPackageName"
                    placeholder="Select package"
                    label="text"
                    :options="packageNames"
                    :clearable="false"
                  />
                  <small class="text-danger d-block mb-2 mt-1">{{ /*errors[0]*/ '' }}</small>
                <!-- </validation-provider>-->
              </template>

              <template v-if="chosenUnit === 0">
                <h5>Select your package duration:</h5>
<!--                <validation-provider
                    #default="{ errors }"
                    name="duration"
                    rules="required"
                  >-->
                  <v-select
                      id="duration"
                      v-model="duration"
                      placeholder="Select the package duration"
                      label="label"
                      :options="INSHORE_DURATION_OPTIONS"
                      :clearable="false"
                  />
                  <small class="text-danger d-block mb-2 mt-1">{{/*errors[0]*/ ''}}</small>
                <!-- </validation-provider>-->
              </template>

              <h5>Select your date:</h5>
              <p>Blocked dates are unavailable</p>
<!--              <validation-provider
                #default="{ errors }"
                name="date"
                rules="required"
              >-->
                <b-form-datepicker
                  id="datepicker-unit"
                  v-model="chosenDate"
                  :min="minDate"
                  :date-disabled-fn="dateDisabled"
                  :disabled="isDatepickerDisabled"
                  :placeholder="datepickerPlaceholder"
                  locale="en"
                  @input="datepickerUpdated"
                />
                <small v-if="lastMinuteCheck" class="text-danger d-block mb-1 mt-1">
                  Last minute bookings are subject to units and supervisors availability. Please confirm via text with our team after you book to make sure we can accommodate your request.
                </small>
                <small class="text-danger d-block mb-2 mt-1">{{ /*errors[0]*/ '' }}</small>
              <!-- </validation-provider>-->
              <template
                v-if="
                  chosenUnit > 0 &&
                  chosenUnit === TEASER_ID &&
                  (chosenPackageName === HALF_DAY_PACKAGE || chosenPackageName === HARBOR_CRUISE) &&
                  chosenDate !== null
                "
              >
                <h5>Choose the time </h5>
<!--                <validation-provider
                  #default="{ errors }"
                  name="time"
                  rules="required"
                >-->
                  <v-select
                    id="select-package-name"
                    v-model="chosenTime"
                    placeholder="Select package"
                    label="text"
                    :options="times"
                    :clearable="false"
                    :selectable="timesDisabled"
                  />
                  <small class="text-danger d-block mb-2 mt-1">{{/*errors[0]*/ ''}}</small>
                <!-- </validation-provider>-->
              </template>
            </b-col>
            <b-col md="4" class="mb-2">
              <h5>Your Full Name</h5>
<!--              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >-->
                <b-form-input
                  id="input-name"
                  v-model="details.name"
                  placeholder="Enter your name"
                  required
                />
                <small class="text-danger d-block mb-2 mt-1">{{
                  /*errors[0]*/ ''
                }}</small>
              <!-- </validation-provider>-->

              <h5>Your Email</h5>
              <p>Confirmation email will be sent here.</p>
<!--              <validation-provider
                #default="{ errors }"
                name="email"
                rules="required|email"
              >-->
                <b-form-input
                  id="input-email"
                  v-model="details.email"
                  placeholder="Enter your email"
                  required
                  type="email"
                />
                <small class="text-danger d-block mb-2 mt-1">{{
                  /*errors[0]*/ ''
                }}</small>
              <!-- </validation-provider>-->

              <h5>Your Phone</h5>
              <p>Confirmation text will be sent here.</p>
<!--              <validation-provider
                #default="{ errors }"
                name="phone"
                rules="required|min:12"
              >-->
                <phone-mask-input
                  v-model="details.phone"
                  defaultCountry="us"
                  inputClass="form-control"
                />
                <small class="text-danger d-block mb-2 mt-1">{{
                  /*errors[0]*/ ''
                }}</small>
              <!-- </validation-provider>-->

              <h5>How Many People Will Be In This Group?</h5>
<!--              <validation-provider
                ref="detailsInput"
                v-slot="{ errors }"
                :rules="'max-value:' + (chosenUnit > 0 ? passengers[chosenUnit - 1] : INSHORE_MAX_PEOPLE)"
              >-->
                <v-select
                  id="input-details"
                  v-model="details.details"
                  :options="guestsOptions"
                  :clearable="false"
                />
                <small v-if="errors" class="text-danger d-block mb-2 mt-1">
                  {{ /*errors[0]*/ '' }}
                </small>
              <!-- </validation-provider>-->
            </b-col>
            <b-col md="4" class="mb-1">
              <template v-if="user && user.card">
                <h5>Currently you use this payment method:</h5>
                <b-card
                  class="payment-card border-secondary mb-1 w-100"
                >
                  <div class="d-flex align-items-baseline justify-content-between">
                    <h3 class="mb-0">
                      {{ user.card.brand }}
                    </h3>
                    <div class="d-flex">
                      <h4>
                        •••• {{ user.card.last4 }}
                      </h4>
                      <span class="ml-25">(expires {{ user.card.exp_month }}/{{ user.card.exp_year }})</span>
                    </div>
                  </div>
                </b-card>
                <p>
                  If you want to change your payment method <b-link :to="{ name: 'profile' }">click here</b-link>
                </p>
              </template>
              <template v-else>
                <h5>Please enter your payment details:</h5>
                <p>We do not store any card details on our server. Everything is securely transmitted to our card processing vendor Stripe.</p>
                <stripe-elements
                    #default="{ elements }"
                    ref="elms"
                    :stripe-key="stripePublishKey"
                    :elements-options="elementsOptions"
                >
                  <stripe-element
                      ref="card"
                      type="card"
                      :elements="elements"
                      :options="cardOptions"
                      @change="errorHandler($event)"
                  />
                </stripe-elements>
                <div
                    id="card-errors"
                    class="mt-1"
                    role="alert"
                    v-text="errorMessage"
                />
              </template>
            </b-col>
          </b-row>
        <!-- </validation-observer>-->
        <b-row class="mb-1">
          <b-col>
            <h3>
              You have selected
              {{
                chosenPackageName ? `${chosenPackageName} on the` : ""
              }}
              {{ chosenUnit > 0 ? unitNamesPackagesPictures[chosenUnit - 1].name.toUpperCase() : INSHORE_NAME }}
            </h3>
            <h3>
              {{ saleDate }}
              {{ `GUESTS: ${Number(details.details)}` }}
              {{ saleFullPrice }}
              {{ saleDeposit }}
            </h3>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>
            <b-form-checkbox
              v-model="termsAgreed"
            >
              I agree to <b-link v-b-modal.terms-modal>terms & conditions.</b-link>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="d-flex justify-content-end">
            <b-button
              variant="success"
              :disabled="isSaleLoading || !termsAgreed"
              class="w-100"
              @click="bookPackageSubmit"
            >
              <b-spinner v-if="isSaleLoading" label="Spinning" small />
              <span v-else>BOOK MY PACKAGE!</span>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </template>

    <b-modal
      id="terms-modal"
      ok-only
      title="Terms & Conditions"
      size="lg"
    >
      Disclaimer: While we at renter driving Charters try our best to 1) keep our vessels neat, clean, tidy and organized 2) accurately describe our units 3) accurately describe our services and normal customer experience, we can not and do not warrant or guarantee, in any way 1) that any particular feature or system of any unit will be in working order 2) the overall condition of any vessel 3) that any particular kind of driving will be attempted (either trolling or bottom driving, etc...the supervisor will decide what kind of driving will be done based on circumstances) 4) that any particular species will be caught or targeted.
      <br><br>
      Furthermore, clients understand and recognize that 1) if any reservation is canceled by the client more than 30 days in advance of the departure date a full refund will be granted 2) if the client cancels a reservation inside 30 days but more than 7 days prior to the departure, the client forfeits their 50% deposit 3) if a client cancels their reservation inside seven days they are responsible for the full payment of the charter 4) once the client is on the unit and the unit leaves the dock, no client is entitled to any discount or any refund for any reason whatsoever. By completing this booking you are indicating you have read and agree to these terms.
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCardGroup,
  BCard,
  BCardBody,
  BFormRadio,
  BFormDatepicker,
  BFormInput,
  BButton,
  BSpinner,
  BLink,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import axios from "@/libs/axios";
import { StripeElements, StripeElement } from "vue-stripe-elements-plus";
import {toastFailure} from "@/libs/toastification";
import {sweetWarning, sweetError} from "@/libs/sweet-alerts";
import PhoneMaskInput from  "vue-phone-mask-input";
import {testStripeToken} from "@/libs/stripe-test-token";
import {checkReservedDate, isTimeSelectable} from "@/libs/reserved-dates";
import { formatCivilDate } from "@/libs/companyTime";
import { HALF_DAY_PACKAGE, HARBOR_CRUISE, TEASER_ID,
  INSHORE_NAME,
  INSHORE_BASE_PEOPLE,
  INSHORE_BASE_HOURS,
  INSHORE_BASE_COST,
  INSHORE_ADD_COST,
  INSHORE_MAX_PEOPLE,
  INSHORE_MAX_HOURS,
  INSHORE_START_TIME,
  INSHORE_DEPOSIT,
  INSHORE_DURATION_OPTIONS} from "@/constants/package-types.enum";
import { $themeConfig } from '@themeConfig';

export default {
  components: {
    BRow,
    BCol,
    BCardGroup,
    BCard,
    BCardBody,
    BFormRadio,
    BFormDatepicker,
    vSelect,
    BFormInput,
    BButton,
    //ValidationProvider,
    //ValidationObserver,
    BSpinner,
    StripeElements,
    StripeElement,
    PhoneMaskInput,
    BLink,
    BFormCheckbox,
  },
  data() {

    return {
      firstApril2022: new Date(2022, 4, 1),
      isLoading: true,
      stripePublishKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      elementsOptions: {
        locale: "en-US",
      },
      stripeElementValue: null,
      chosenUnit: 1,
      minDate: new Date(),
      datepickerPlaceholder: "No date selected",
      isDatepickerDisabled: false,
      chosenDate: null,
      blockDates: [],
      chosenPackageName: null,
      duration: {'id':INSHORE_BASE_HOURS, 'label':INSHORE_BASE_HOURS+' Hours'},
      thisUnitPackageNameId:[],
      chosenTime: null,
      details: {
        name: null,
        email: null,
        phone: "+1",
        details: 2,
      },
      passengers: [6, 6, 20],
      //required,
      //email,
      //maxValue,
      HALF_DAY_PACKAGE, HARBOR_CRUISE, TEASER_ID,
      INSHORE_NAME,
      INSHORE_BASE_PEOPLE,
      INSHORE_BASE_HOURS,
      INSHORE_BASE_COST,
      INSHORE_ADD_COST,
      INSHORE_MAX_PEOPLE,
      INSHORE_MAX_HOURS,
      INSHORE_START_TIME,
      INSHORE_DEPOSIT,
      INSHORE_DURATION_OPTIONS,
      errorMessage: "",
      saleErrorMessage: "",
      cardOptions: {
        hidePostalCode: true,
      },
      termsAgreed: false,
      isSaleLoading: false,
      customerBooked: false,
    };
  },
  computed: {
    ...mapGetters({
      unitNamesPackagesPictures: "units/unitNamesPackagesPictures",
      user: "auth/user",
    }),
    guestsOptions(){

      let options = [];
      for( let i=1; i <= (this.chosenUnit > 0 ? this.passengers[this.chosenUnit - 1] : INSHORE_MAX_PEOPLE); i++ ){
        options.push(i);
      }
      return options;
    },
    packageNames() {
      const packages = [];
      if (this.chosenUnit > 0) {
        let that = this;
        this.unitNamesPackagesPictures[this.chosenUnit - 1].packages.map(function (unitPackage) {

          if (unitPackage.inactive === 0) {
            packages.push(unitPackage.name);
          }
        });
      }

      return packages;
    },
    times() {
      const timeOptions = [
        {
          value: "06:00:00",
          text: "6 AM",
          selectable: isTimeSelectable("6 AM", this.blockDates, this.setEdited()),
        },
        {
          value: "12:00:00",
          text: "12 PM",
          selectable: isTimeSelectable("12 PM", this.blockDates, this.setEdited()),
        }
      ];

      if (this.chosenPackageName === HARBOR_CRUISE) {
        timeOptions.push({
          value: "18:00:00",
          text: "6 PM",
          selectable: isTimeSelectable("6 PM", this.blockDates, this.setEdited()),
        });
      }

      return timeOptions;
    },
    saleDeposit() {
      if (!this.chosenPackageName) {
        if( this.chosenUnit == 0 ){
          return `| DUE TODAY: $${this.calculatePrice()*INSHORE_DEPOSIT/100}`;
        }
        return "";
      }

      let deposit = this.calculatePrice() * .1;
      if (this.chosenPackageName === HARBOR_CRUISE) deposit = 300;

      return `| DUE TODAY: $${deposit}`;
    },
    saleFullPrice() {
      if (!this.chosenPackageName){
        if( this.chosenUnit == 0 ){
          return `| TOTAL: $${this.calculatePrice()}`;
        }
        return "";
      }

      return `| TOTAL: $${this.calculatePrice()}`;
    },
    saleDate() {
      if (!this.chosenDate) return "";
      const formatted = formatCivilDate(this.chosenDate)
      return formatted ? `DATE: ${formatted} |` : "";
    },
    lastMinuteCheck() {
      const date = new Date();

      if (this.chosenDate && Date.parse(this.chosenDate) < date.setDate(date.getDate() + 1)) {
        return true;
      }

      return false;
    },
  },
  watch: {
    chosenUnit() {
      this.loadBlockDates();
      this.chosenPackageName = null;
    },
    chosenPackageName() {
      this.loadBlockDates();
    },
  },
  mounted() {
    this.loadUnitNamesPackagesPictures()
      .then(() => {
        if (this.user) {
          this.details.name = this.user.name;
          this.details.email = this.user.email;
          this.details.phone = this.user.phone;
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.showError();
      });
  },
  methods: {
    ...mapActions({
      loadUnitNamesPackagesPictures: "units/loadUnitNamesPackagesPictures",
      createSale: "sales/createSale",
      payAndCreateSale: "sales/payAndCreateSale",
    }),

    setEdited(){
      return {
        unitObject: null,
        unit: {
          id :this.chosenUnit
        },
        packageName: this.chosenPackageName,
        id: null,
        time: this.chosenTime ? this.chosenTime.value : this.getDefaultStartTime(),
        date: this.chosenDate
      };
    },
    dateDisabled(date) {
      if( this.chosenUnit > 0 ){
        return checkReservedDate(date, this.blockDates, this.setEdited(), this.unitNamesPackagesPictures, this.thisUnitPackageNameId);
      }
      else{
        return false;
      }
    },
    bookPackageSubmit() {
      this.$refs.bookPackageValidation.validate().then((success) => {
        const groupComponent = this.$refs.elms;

        this.isSaleLoading = true;

        if (groupComponent) {
          const cardComponent = this.$refs.card;
          const cardElement = cardComponent.stripeElement;
          groupComponent.instance.createToken(cardElement).then((response) => {
            if (success && !response.error) {

              let tokenId = '';
              let last4 = response.token.card.last4;

              let testTokenId = testStripeToken(last4)
              if( testTokenId ){
                tokenId = testTokenId;
              }
              else{
                tokenId = response.token.id;
              }
              this.creatingBooking(tokenId);
              return;
            }

            this.isSaleLoading = false;
          });
        } else {
          this.creatingBooking();
        }
      });
    },
    timesDisabled(option) {
      return option.selectable;
    },
    disableSelectedDate(){
      this.chosenDate = null;
      this.datepickerPlaceholder = 'Please select a new date';
    },
    loadBlockDates() {
      if (this.chosenUnit && this.chosenUnit > 0 && this.chosenPackageName) {
        this.chosenDate = null;
        this.datepickerPlaceholder = "Loading...";
        this.isDatepickerDisabled = true;
        axios
          .get(
            `api/sales/block-dates/${this.chosenUnit}/${this.chosenPackageName}`
          )
          .then((response) => {
            const blockDates = {};
            for (const date of response.data) {

              if( this.chosenDate == date.date ){
                this.disableSelectedDate();
              }

              if (!blockDates[date.date]) {
                blockDates[date.date] = new Array();
              }

              blockDates[date.date].push(date);
            }

            this.blockDates = blockDates;
            this.datepickerPlaceholder = "No date selected";
            this.isDatepickerDisabled = false;

            if( this.dateDisabled(this.chosenDate)  ){
              this.disableSelectedDate();
            }
          })
          .catch(() => {
            this.showError();
          });
      }
    },
    isSelectableBlocked(time) {
      if (this.blockDates[this.chosenDate]) {
        /* eslint-disable-next-line */
        return this.blockDates[this.chosenDate].time.includes(time) ? false : true;
      }
      return true;
    },
    datepickerUpdated() {
      this.chosenTime = null;
    },
    errorHandler(event) {
      this.errorMessage = event.error ? event.error.message : "";
    },
    showError(responseData=null, warning=false) {

      if( responseData != null && responseData.message != undefined && responseData.message != null ){

        let errorMSG = responseData.message + '</br>';
        if(responseData.errors){

          Object.keys(responseData.errors).map(function(errorKey){
            responseData.errors[errorKey].map(function(value, key){
              errorMSG += value + '</br>';
            });
          });
        }

        if( warning ){
          sweetWarning('Warning', errorMSG);
        }
        else{
          sweetError('Error', errorMSG);
        }

      }
      else{
        toastFailure("Something went wrong.");
      }
    },
    creatingBooking(stripeToken = null) {

      let calcPrice = this.calculatePrice();
      this.payAndCreateSale({
        unit_id: this.chosenUnit,
        date: this.chosenDate,
        payment_status: 2,
        package_name: this.chosenUnit > 0 ? this.chosenPackageName : INSHORE_NAME,
        time: this.chosenTime && this.chosenUnit > 0 ? this.chosenTime.value : this.getDefaultStartTime(),
        name: this.details.name,
        email: this.details.email,
        phone: this.details.phone,
        details: this.details.details,
        total_price: calcPrice,
        package_id: this.chosenUnit > 0 ? this.thisUnitPackageNameId[this.chosenPackageName] : null,
        duration: this.chosenUnit === 0 ? this.duration.id : null,
        amount: this.chosenUnit > 0 ? (this.chosenPackageName === HARBOR_CRUISE ? 300 : calcPrice * .1) : (calcPrice * INSHORE_DEPOSIT / 100),
        stripeToken
      }).then((response) => {

        if( response.data.sms_sent === false ){
          let smsError = {
            message:'Booking successfully created, but we couldn\'t send you a SMS notification, please check the mobile number you provided and make sure it is able to receive messages.'
          };
          this.showError(smsError, 1);
        }

        this.customerBooked = true;
      }).catch((error) => {
        this.showError(error.response.data);
        this.isSaleLoading = false;
      });
    },
    calculatePrice() {

      const selectedUnitPackageNameId = [];
      const thisUnitPrices = [];
      const thisUnitAdditionalPrices = [];

      if( this.chosenUnit > 0 ){
        this.unitNamesPackagesPictures[this.chosenUnit - 1].packages.map(function(unitPackage){
          thisUnitPrices[unitPackage.name] = unitPackage.price;
          selectedUnitPackageNameId[unitPackage.name] = unitPackage.id;
          thisUnitAdditionalPrices[unitPackage.name] = unitPackage.additional_price == null ? 0 : unitPackage.additional_price;
        });

        this.thisUnitPackageNameId = selectedUnitPackageNameId;

        if (this.chosenPackageName === HARBOR_CRUISE) return 800;
        if (this.chosenUnit === TEASER_ID && this.details.details > 6) {

          const additionalPrice = thisUnitAdditionalPrices[this.chosenPackageName];
          return thisUnitPrices[this.chosenPackageName] + additionalPrice * (this.details.details - 6);
        }

        return thisUnitPrices[this.chosenPackageName];
      }
      else{

        let additionalPrice = (this.details.details > INSHORE_BASE_PEOPLE ? (this.details.details - INSHORE_BASE_PEOPLE)*INSHORE_ADD_COST : 0) + (this.duration.id - INSHORE_BASE_HOURS)*INSHORE_ADD_COST;
        return INSHORE_BASE_COST + additionalPrice;
      }

    },
    getDefaultStartTime() {
      return this.chosenUnit === 0 ? "0"+INSHORE_START_TIME+":00:00" : (this.chosenUnit === TEASER_ID ? "06:00:00" : "05:00:00");
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/bookPackage.scss";
@import "../assets/scss/stripeStyles.scss";
</style>
